module.exports = __webpack_public_path__ + "static/media/S2N4-5.1d89b5fc.svg";